import { binarySideOf, SUBSTRING_NO_WORDS, SUBSTRING_YES_WORDS } from '@/client/utils/binary-option-words';

export type OptionTone = 'yes' | 'no' | undefined;

const normalizeOptionValue = (value: string) => value.trim().toLowerCase();

/**
 * Colour side for an option label. Word lists are shared with the trade panel
 * (utils/binary-option-words) so a position badge and the trade panel agree.
 * - A whole-label match against the shared lists wins (higher/lower, over/under, ...).
 * - Otherwise the legacy keywords still match as substrings ("Up 5%", "跌破"),
 *   yes first, exactly as before.
 */
export const getOptionTone = (value?: string): OptionTone => {
  if (!value) return undefined;

  const side = binarySideOf(value);
  if (side) return side;

  const v = normalizeOptionValue(value);
  if (SUBSTRING_YES_WORDS.some(k => v.includes(k))) return 'yes';
  if (SUBSTRING_NO_WORDS.some(k => v.includes(k))) return 'no';

  return undefined;
};
